import React from "react";
import { ChangeEvent, KeyboardEvent } from "react";

import TreeViewItem, { ITreeViewItem, TreeViewEvent } from "./TreeViewItem";

import "./TreeView.css";

interface ITreeViewProps {
    items: ITreeViewItem[];

    id?: string;
    name?: string;

    onNewItem?: (e: TreeViewEvent) => void;
    onRemoveItem?: (e: TreeViewEvent) => void;
    onUpdateItem?: (e: TreeViewEvent) => void;

    itemNameRender?: (item: any) => React.ReactChild;
}

interface ITreeViewState {
    isNewFocused: boolean;
    newItemText: string;
    newItemTextSecondary: string;
    newItemCpt: string;

    [name: string]: boolean | string;
}

class TreeView extends React.Component<ITreeViewProps, ITreeViewState> {
    constructor(props: Readonly<ITreeViewProps>) {
        super(props);

        this.state = {
            isNewFocused: false,
            newItemText: "",
            newItemTextSecondary: "",
            newItemCpt: ""
        };

        this.handleItemAdd = this.handleItemAdd.bind(this);
        this.handleItemRemove = this.handleItemRemove.bind(this);
        this.handleItemUpdate = this.handleItemUpdate.bind(this);
        this.handleInputKeydown = this.handleInputKeydown.bind(this);
        this.addItem = this.addItem.bind(this);
        this.inputChanged = this.inputChanged.bind(this);
        this.focusNew = this.focusNew.bind(this);
        this.blurNew = this.blurNew.bind(this);
    }

    public render() {
        return (
            <div id={this.props.id} className="treeview">
                <div className="treeview-main-row" />
                {this.props.items.map((a, i) => <TreeViewItem key={a.name} item={a} index={i} isTopLevel={true} onNewItem={this.handleItemAdd} onRemoveItem={this.handleItemRemove} onUpdateItem={this.handleItemUpdate} itemNameRender={this.props.itemNameRender} />)}
                <div className="treeview-item-input">
                    <div className="treeview-item-input-left">
                        <input type="text" className={"input-light" + (this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary ? " input-active" : "")} placeholder={`Add option...`} name="newItemText" value={this.state.newItemText} onChange={this.inputChanged} onFocus={this.focusNew} onBlur={this.blurNew} onKeyDown={this.handleInputKeydown} />
                        {this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary ? <input type="text" className={"input-light input-small input-active"} placeholder={this.state.isNewFocused ? "Short name" : ""} name="newItemTextSecondary" value={this.state.newItemTextSecondary} onChange={this.inputChanged} onFocus={this.focusNew} onBlur={this.blurNew} onKeyDown={this.handleInputKeydown} /> : ""}
                        {this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary ? <input type="number" className={"input-light input-small input-active"} placeholder={this.state.isNewFocused ? "Cpt" : ""} name="newItemCpt" value={this.state.newItemCpt} onChange={this.inputChanged} onFocus={this.focusNew} onBlur={this.blurNew} onKeyDown={this.handleInputKeydown} /> : ""}
                    </div>
                    {
                        this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary
                            ? <button type="button" className="button" onClick={this.addItem} disabled={!this.state.newItemText}><i className="icon-plus" /></button>
                            : ""
                    }
                </div>
            </div>
        );
    }

    private handleItemAdd(e: TreeViewEvent) {
        if (this.props.onNewItem) {
            this.props.onNewItem(e);
        }
    }

    private handleItemRemove(e: TreeViewEvent) {
        if (this.props.onRemoveItem) {
            this.props.onRemoveItem(e);
        }
    }

    private handleItemUpdate(e: TreeViewEvent) {
        if (this.props.onUpdateItem) {
            this.props.onUpdateItem(e);
        }
    }

    private handleInputKeydown(e: KeyboardEvent<HTMLInputElement>) {
        if (e.key === "Enter") {
            e.preventDefault();
            this.addItem();
        }
    }

    private addItem() {
        if (!this.state.newItemText) {
            return;
        }

        if (this.props.onNewItem) {
            this.props.onNewItem({
                origin: this,
                shortValue: this.state.newItemTextSecondary,
                value: this.state.newItemText,

                extra: {
                    cpt: this.state.newItemCpt
                }
            });
        }

        this.setState({
            newItemText: "",
            newItemTextSecondary: "",
            newItemCpt: ""
        });
    }

    private inputChanged(e: ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            [name]: value
        });
    }

    private focusNew() {
        this.setState({ isNewFocused: true });
    }

    private blurNew() {
        if (this.state.newItemText) {
            this.setState({ isNewFocused: false });
        }
        else {
            this.setState({ isNewFocused: false, newItemTextSecondary: "", newItemCpt: "" });
        }
    }
}

export default TreeView;
